import ReactGA from 'react-ga4'

ReactGA.initialize('G-T744XTR4DR')

export default ReactGA
